import React from 'react'

export default function NotFound() {
  return <div className="items-center justify-center text-4xl align-middle">404 Not Found</div>
}
